import React from 'react';

import Box from '@mui/material/Box';
import { Storage } from 'aws-amplify';

import { AWS_CONFIG } from '../../../common/components/tfa-auth/config/config';
import { useAppSelector } from '../../../common/hooks/reduxHooks';

type Props = {
  filename: string;
};

const ScanThumbnail: React.FC<Props> = ({ filename }) => {
  const { user } = useAppSelector((state) => state.model);
  const userId = user?.id;
  const [imageUrl, setImageUrl] = React.useState('');
  const [seed, setSeed] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);
  const reset = () => {
    setSeed(Math.random());
  };

  const getImageUrl = () => {
    try {
      if (!!!userId) return '';
      const result = /[^/]*$/.exec(filename)?.[0].split('.')[0];
      if (!!!result) return;
      Storage.get(`${userId}/${result}.png`, {
        level: 'public',
        bucket: AWS_CONFIG.Storage.bucket,
        region: 'us-east-1',
      }).then((url) => {
        setImageUrl(url);
      });
    } catch (error: any) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    setLoaded(false);
    getImageUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filename]);

  const downloadPdf = () => {
    if (!!!userId) return;
    if (!loaded) return;
    const bucketUrl = process.env.REACT_APP_AWS_PDF_BUCKET ?? '';
    const result = /[^/]*$/.exec(filename)?.[0].split('.')[0];
    if (!!!result) return;
    const fileUrl = `${userId}/${result}.pdf`;
    Storage.get(fileUrl, {
      level: 'public',
      bucket: bucketUrl,
      region: 'us-east-1',
    }).then((url) => {
      window.open(url, '_blank');
    });
  };

  return (
    <Box
      onClick={downloadPdf}
      key={seed}
      component='img'
      src={imageUrl}
      onError={() => {
        setTimeout(() => reset(), 350);
      }}
      onLoad={() => setLoaded(true)}
      sx={{
        objectFit: 'cover',
        width: '87px',
        height: '115px',
        borderRadius: '16px',
        visibility: loaded ? 'visible' : 'hidden',
        cursor: 'pointer',
        marginBottom: '8px',
      }}
    />
  );
};

export default ScanThumbnail;
